module.exports = __webpack_public_path__ + "img/result_txt_e.acc3fdc0.png";